module.exports = "<div>\n  <span *ngIf=\"mdIcon; then icon else img\"></span>\n  <ng-template #icon>\n    <mat-icon [svgIcon]=\"mdIcon\"></mat-icon>\n  </ng-template>\n  <ng-template #img>\n    <img *ngIf=\"item.imgUrl\" [src]=\"item.imgUrl\"/>\n  </ng-template>\n  <span>{{ item.name }}</span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/list-item/list-item.component.html
// module id = ./src/app/shared/list-item/list-item.component.html
// module chunks = main